/**
 * MediaPlayback Styled Component
 */

import styled, { StyledComponent } from 'styled-components';

const MediaPlaybackDiv: StyledComponent<any, any> = styled.div``;

export default MediaPlaybackDiv;
